import { Typography, Box } from "@material-ui/core";

export const DisplayRowField = (props) => (
  <Box display="flex" mb={1}>
    <Box mr={1}>
      <Typography variant="body2" display="block">
        {props.label}:
      </Typography>
    </Box>
    <Box>
      <Typography variant="body2" style={{ fontWeight: "bold" }}>
        {props.value}
      </Typography>
    </Box>
  </Box>
);
